export default __webpack_public_path__ + "static/media/la1.2.588c54cc.png";